<div [ngClass]="{ 'background-image-hp': isBackgroundImage }">
  <app-loader></app-loader>
  @if (authService.userIsLogged()) {
    <app-idle></app-idle>
  }

  <app-dialog
    #pendingReviewDialog
    [dialogLabel]="'pendingReviewDocuments'"
    [id]="pendingReviewUsername"
    [questionMark]="false"
    [message]="pendingReviewDialogMessage"
    [detailsBody]="pendingReviewDialogAdditionalInfo"
    [okButtonText]="'platform.user-documents.review-required.go-to-page'"
    [cancelButtonText]="'platform.buttons.cancel'"
    (value)="onPendingReviewDialogAction($event.confirm)"
  >
  </app-dialog>

  <router-outlet></router-outlet>
</div>
